import { render, staticRenderFns } from "./TheTabCategoriaLinae.vue?vue&type=template&id=09e88ce2&"
import script from "./TheTabCategoriaLinae.vue?vue&type=script&lang=js&"
export * from "./TheTabCategoriaLinae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports